import React, { useState, useEffect } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import Stepper from "../Layout/Stepper";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { GetPremium } from "../../Services/Hospicash/Quotation";
import { CreateHospicashLead } from "../../Services/Hospicash/Lead";
import Toast from "../../Components/Alerts/Toast";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarDaysIcon } from "@heroicons/react/24/outline";

const InsurancePortal = () => {
	const [plans, setPlans] = useState([]);
	useEffect(() => {
		GetPremiums();
	}, []);
	const GetPremiums = async () => {
		try {
			const data = await GetPremium();

			if (data.status === "Success") {
				const formatted = data.premiumDetails.map((p, index) => ({
					premiumUID: p.premiumUID,
					dailyCashAllowance: Number(p.dailyCashAllowance),
					homeCityICUBenefit: Number(p.homeCityICUBenefit),
					nonHomeCityICUBenefit: Number(p.nonHomeCityICUBenefit),
					convalescenceBenefit: Number(p.convalescenceBenefit),
					totalSA: Number(p.totalSA),
					premium: Number(p.premium),
					gst: Number(p.gst),
					totalPremium: Number(p.totalPremium),
					id: index + 1,
				}));

				console.log("Formatted:", formatted);
				setPlans(formatted);
			}
		} catch (err) {
			console.error("Catch error:", err);
		}
	};

	const [selectedIds, setSelectedIds] = useState([]);
	useEffect(() => {
		setSelectedIds(plans.map((p) => p.id));
	}, [plans]);

	const [compareIds, setCompareIds] = useState([]);
	const [showModal, setShowModal] = useState(false);

	const toggleSelection = (id) => {
		setSelectedIds((prev) =>
			prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
		);
	};

	const toggleCompare = (id) => {
		setCompareIds((prev) =>
			prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
		);
	};
	const [planDetailsModal, setPlanDetailsModal] = useState(null);

	const clearAllCompare = () => setCompareIds([]);
	const steps = ["Select Plan", "Details", "Checkout", "Confirmation"];

	const [purchaseModal, setPurchaseModal] = useState(null);
	const [fullName, setFullName] = useState("");
	const [mobile, setMobile] = useState("");
	const [email, setEmail] = useState("");
	const [submitted, setSubmitted] = useState(false);
	const [title, setTitle] = useState(null);
	const [dob, setDob] = useState("");
	const [loading, setLoading] = useState(false);
	const [toast, setToast] = useState({ message: "", type: "" });
	const [emailError, setEmailError] = useState("");

	const navigate = useNavigate();

	const handleDobChange = (date) => {
		setDob(date);
	};
	const showToast = (message, type = "success") => {
		setToast({ message, type });
		setTimeout(() => setToast({ message: "", type: "" }), 3000);
	};
	const formattedDob = dob
		? `${dob.getDate().toString().padStart(2, "0")}-${(dob.getMonth() + 1)
				.toString()
				.padStart(2, "0")}-${dob.getFullYear()}`
		: "";

	const handleEmailChange = (e) => {
		const value = e.target.value;
		setEmail(value);

		if (value && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
			setEmailError("Enter a valid email address");
		} else {
			setEmailError("");
		}
	};
	const handleSubmit = async (e) => {
		e?.preventDefault();

		setSubmitted(true);

		if (!fullName || !mobile || !title) return;
		if (email && emailError) {
			showToast("Please enter a valid email ID", "error");
			return;
		}
		if (loading) return;

		setLoading(true);

		try {
			const res = await CreateHospicashLead(
				title,
				fullName,
				mobile,
				email,
				formattedDob,
				purchaseModal.premiumUID
			);

			console.log("API Response:", res.data);

			if (res?.data?.status === "Success") {
				const uid = res.data.hospicashLeadUID;
				showToast("Lead created successfully", "success");

				setTimeout(() => {
					navigate(`/Hospicash/Quotation/Customer-Details/${uid}`);
				}, 1000);
			} else {
				showToast("Failed to create lead", "error");
			}
		} catch (err) {
			alert(err.message);
		}

		setLoading(false);
	};

	return (
		<div className="min-h-screen text-gray-800">
			<header className="bg-white border-b sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-6 py-4">
					<div className="flex items-center justify-center gap-8 md:gap-12">
						<Stepper steps={steps} currentStep={1} />
					</div>
				</div>
			</header>

			<main className="max-w-7xl mx-auto px-6 py-8">
				<div className="grid grid-cols-12 gap-6 min-h-[calc(100vh-120px)]">
					{/* LEFT: Filters / Sum Assured & Features */}
					<aside className="col-span-12 lg:col-span-4 lg:sticky lg:top-[10px] self-start">
						<div className="bg-[var(--surface)] rounded-2xl shadow-sm p-6 max-h-[calc(100vh-2rem)] overflow-y-auto">
							<h3 className="text-xl font-semibold mb-4">Sum Assured</h3>

							<div className="space-y-3">
								{plans.map((item, idx) => {
									const on = selectedIds.includes(item.id);
									return (
										<div
											key={item.id}
											className={`flex items-center justify-between p-3 rounded-lg transition-shadow ${
												on
													? "bg-blue-50 shadow-sm border border-blue-100"
													: "bg-white border border-gray-100"
											}`}
										>
											<div className="flex items-center gap-3">
												<div>
													<div className="text-xs">Sum Assured:</div>
													<div className="font-medium text-xl text-gray-600">
														₹ {item.totalSA.toLocaleString()}
													</div>
												</div>
											</div>

											<button
												onClick={() => toggleSelection(item.id)}
												className={`w-14 h-7 flex items-center p-1 rounded-full transition-colors ${
													on ? "bg-primary" : "bg-gray-200"
												}`}
												aria-pressed={on}
											>
												<div
													className={`bg-white w-5 h-5 rounded-full shadow transform transition-transform ${
														on ? "translate-x-7" : ""
													}`}
												/>
											</button>
										</div>
									);
								})}
							</div>
						</div>
					</aside>

					{/* RIGHT: Results */}
					<section className="col-span-12 lg:col-span-8">
						<div className="flex items-center justify-between mb-6">
							<div>
								<h2 className="text-2xl font-bold">
									Select the best suitable plans at exclusive rates.
								</h2>
								<p className="text-sm text-gray-500 mt-1">Showing results</p>
							</div>

							<div className="flex items-center gap-4">
								<div className="text-sm text-gray-600">Sort</div>
								<select className="border rounded-md px-3 py-2 text-sm">
									<option>Recommended</option>
									<option>Lowest Premium</option>
									<option>Highest Sum Assured</option>
								</select>
							</div>
						</div>

						<div className="grid grid-cols-1 md:grid-cols-1 gap-6">
							{plans
								.filter((p) => selectedIds.includes(p.id))
								.map((item) => (
									<article
										key={item.id}
										className="bg-[var(--surface)] rounded-2xl shadow-lg hover:shadow-xl transition-shadow border border-transparent"
									>
										<div className="p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
											{/* left - logo & title */}
											<div className="flex items-center gap-4 w-full md:w-2/3">
												<div className="w-20 h-20 flex items-center justify-center rounded-lg">
													<img
														src="https://assets.futuregenerali.in/header-assets/updated-header-logo/logo.svg"
														alt="provider"
														className="w-full h-full object-contain"
													/>
												</div>

												<div className="h-14 w-px bg-gray-300"></div>

												<div>
													<div className="text-lg font-semibold">
														Generali Central India Insurance Company Ltd
													</div>

													<div className="mt-3 flex flex-col sm:flex-row gap-3 text-gray-700 text-sm">
														<div className="flex items-center gap-2">
															<span className="text-xs text-gray-400">
																Sum Assured
															</span>
															<span className="text-lg font-semibold">
																₹ {item.totalSA.toLocaleString()}
															</span>
														</div>

														<div className="flex items-center gap-2">
															<span className="text-xs text-gray-400">
																Premium
															</span>
															<span className="text-lg font-semibold">
																₹ {item.totalPremium}
															</span>
														</div>
													</div>
												</div>
											</div>

											{/* right - actions */}
											<div className="w-full md:w-1/3 flex flex-col items-end gap-3">
												<div className="flex gap-3 w-full md:w-auto">
													<button
														onClick={() => setPurchaseModal(item)}
														className="px-5 py-2 rounded-lg font-semibold shadow bg-primary text-white"
													>
														Buy Now
													</button>

													<button className="px-4 py-2 rounded-lg border border-gray-400 text-primary font-semibold">
														Share
													</button>
												</div>

												<div className="w-full md:w-auto mt-2 flex flex-col items-end gap-2">
													<button
														onClick={() => setPlanDetailsModal(item)}
														className="text-xs text-primary mt-1 hover:underline"
													>
														View All Details →
													</button>
												</div>
											</div>
										</div>

										{/* footer features / small */}
										<div className="bg-[var(--muted)] rounded-b-2xl px-6 py-3 text-sm text-gray-600 border-t">
											<div className="flex gap-6 justify-between">
												<div className="flex items-center gap-3">
													<button
														onClick={() => toggleCompare(item.id)}
														className="flex items-center gap-2 text-sm font-medium transition"
													>
														<span
															className={`w-4 h-4 rounded-full border flex items-center justify-center transition ${
																compareIds.includes(item.id)
																	? "border-emerald-600 bg-emerald-600"
																	: "border-gray-400 bg-white"
															}`}
														>
															{compareIds.includes(item.id) && (
																<CheckIcon className="w-2.5 h-2.5 text-white" />
															)}
														</span>

														<span
															className={`text-xs ${
																compareIds.includes(item.id)
																	? "text-emerald-600"
																	: "text-gray-600"
															}`}
														>
															{compareIds.includes(item.id)
																? "Remove from Compare"
																: "Add to Compare"}
														</span>
													</button>
													<span className="text-xs bg-white/60 px-2 py-1 rounded-md">
														Content
													</span>
													<span className="text-xs bg-white/60 px-2 py-1 rounded-md">
														Building
													</span>
												</div>
												<div className="text-sm font-semibold">
													₹ {item.totalPremium}
												</div>
											</div>
										</div>
									</article>
								))}
						</div>
					</section>
				</div>
			</main>

			{/* Compare Bar */}
			{compareIds.length > 1 && (
				<div className="fixed left-0 right-0 bottom-0 p-4 bg-white/95 border-t shadow-lg flex items-center justify-between max-w-7xl mx-auto">
					<div>
						<div className="text-sm text-gray-600">
							{compareIds.length} plans selected for comparison
						</div>
						<div className="text-xs text-gray-400">
							Choose compare to view features side-by-side
						</div>
					</div>

					<div className="flex items-center gap-3">
						<button
							onClick={() => clearAllCompare()}
							className="px-4 py-2 rounded-md border text-sm text-gray-600"
						>
							Clear
						</button>

						<button
							onClick={() => setShowModal(true)}
							className="px-5 py-2 bg-primary text-white rounded-md font-semibold"
						>
							View Comparison
						</button>
					</div>
				</div>
			)}

			{/* Comparison Modal */}
			{showModal && (
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
					<div className="bg-white rounded-2xl max-w-6xl w-full shadow-2xl overflow-hidden">
						{/* HEADER */}
						<div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
							<h3 className="text-xl font-semibold">Compare Plans</h3>

							<button
								onClick={() => setShowModal(false)}
								className="text-sm px-4 py-2 rounded-lg border hover:bg-gray-100 transition"
							>
								Close
							</button>
						</div>

						{/* BODY */}
						<div className="p-6 max-h-[70vh] overflow-auto">
							{/* PLAN CARDS */}
							<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
								{plans
									.filter((p) => compareIds.includes(p.id))
									.map((p) => (
										<div
											key={p.id}
											className="border rounded-2xl shadow-sm hover:shadow-md transition p-5"
										>
											{/* Logo */}
											<div className="flex justify-center">
												<img
													src="https://assets.futuregenerali.in/header-assets/updated-header-logo/logo.svg"
													alt="provider"
													className="h-16 object-contain"
												/>
											</div>

											<div className="h-[1px] bg-gray-200 my-4"></div>

											{/* SECTION 1: SUM ASSURED BREAK-UP */}
											<p className="text-xs font-semibold text-gray-500 mb-3 tracking-wide">
												SUM ASSURED BREAK-UP
											</p>

											<ul className="space-y-3 text-sm">
												<li className="flex justify-between">
													<span className="text-gray-600">
														Daily Hospitalisation benefit
													</span>
													<span className="font-medium">
														₹ {p.dailyCashAllowance.toLocaleString()}
													</span>
												</li>

												<li className="flex justify-between">
													<span className="text-gray-600">
														ICU benefit in home city
													</span>
													<span className="font-medium">
														₹ {p.homeCityICUBenefit.toLocaleString()}
													</span>
												</li>

												<li className="flex justify-between">
													<span className="text-gray-600">
														ICU benefit in other than home city
													</span>
													<span className="font-medium">
														₹ {p.nonHomeCityICUBenefit.toLocaleString()}
													</span>
												</li>

												<li className="flex justify-between">
													<span className="text-gray-600">
														Convalescence benefit for hospitalisation
													</span>
													<span className="font-medium">
														₹ {p.convalescenceBenefit.toLocaleString()}
													</span>
												</li>

												<li className="flex justify-between font-medium text-gray-800">
													<span>Total Sum Assured</span>
													<span>₹ {p.totalSA.toLocaleString()}</span>
												</li>
											</ul>

											<div className="h-[1px] bg-gray-200 my-4"></div>

											{/* SECTION 2: PREMIUM BREAK-UP */}
											<p className="text-xs font-semibold text-gray-500 mb-3 tracking-wide">
												PREMIUM BREAK-UP
											</p>

											<ul className="space-y-3 text-sm">
												<li className="flex justify-between">
													<span className="text-gray-600">Premium</span>
													<span>₹ {p.premium.toFixed(2)}</span>
												</li>

												<li className="flex justify-between">
													<span className="text-gray-600">GST</span>
													<span>₹ {p.gst.toFixed(2)}</span>
												</li>

												<li className="flex justify-between items-center">
													<span className="text-gray-600">Total Premium</span>
													<span className="text-2xl font-bold text-green-700">
														₹ {p.totalPremium}
													</span>
												</li>
											</ul>
										</div>
									))}
							</div>
						</div>

						{/* FOOTER */}
						<div className="p-4 border-t flex items-center justify-between bg-gray-50">
							<p className="text-sm text-gray-600">
								Choose the plan that fits your needs.
							</p>

							<div className="flex items-center gap-3">
								<button
									onClick={() => {
										setShowModal(false);
										clearAllCompare();
									}}
									className="px-4 py-2 rounded-lg border hover:bg-blue-500 transition bg-primary text-white"
								>
									Clear & Close
								</button>

								<button
									onClick={() => setShowModal(false)}
									className="text-sm px-4 py-2 rounded-lg border border-black hover:bg-gray-100 transition"
								>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
			{planDetailsModal && (
				<div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
					<div className="bg-white rounded-2xl max-w-2xl w-full shadow-2xl overflow-hidden">
						{/* HEADER */}
						<div className="flex items-center justify-between px-6 py-4 border-b bg-gray-50">
							<h3 className="text-xl font-semibold">Plan Details</h3>

							<button
								onClick={() => setPlanDetailsModal(null)}
								className="p-2 rounded-full hover:bg-gray-100 transition"
							>
								<XMarkIcon className="w-5 h-5 text-gray-600" />
							</button>
						</div>

						{/* BODY */}
						<div className="p-6 space-y-6 max-h-[65vh] overflow-auto">
							{/* Logo + Name */}
							<div className="flex items-center gap-4">
								<img
									src="https://assets.futuregenerali.in/header-assets/updated-header-logo/logo.svg"
									alt="provider"
									className="h-16 object-contain"
								/>
								<div className="h-14 w-px bg-gray-300"></div>

								<div>
									<h2 className="text-lg font-semibold">
										Generali Central India Insurance Company Ltd
									</h2>
									<p className="text-sm text-gray-500 mt-1">
										Sum Assured & Premium Breakup
									</p>
								</div>
							</div>

							<div className="h-[1px] bg-gray-200"></div>

							{/* Sum Assured Section */}
							<div>
								<h4 className="text-sm font-semibold text-gray-700 mb-3">
									SUM ASSURED BREAK-UP
								</h4>

								<ul className="space-y-3 text-sm">
									<li className="flex justify-between">
										<span>Daily Hospitalisation benefit</span>
										<span className="font-medium">
											₹ {planDetailsModal.dailyCashAllowance.toLocaleString()}
										</span>
									</li>

									<li className="flex justify-between">
										<span>ICU benefit in home city</span>
										<span className="font-medium">
											₹ {planDetailsModal.homeCityICUBenefit.toLocaleString()}
										</span>
									</li>
									<li className="flex justify-between">
										<span>ICU benefit in other than home city</span>
										<span className="font-medium">
											₹{" "}
											{planDetailsModal.nonHomeCityICUBenefit.toLocaleString()}
										</span>
									</li>
									<li className="flex justify-between">
										<span>Convalescence benefit for hospitalisation</span>
										<span className="font-medium">
											₹ {planDetailsModal.convalescenceBenefit.toLocaleString()}
										</span>
									</li>
									<li className="flex justify-between font-semibold text-gray-900">
										<span>Total Sum Assured</span>
										<span>₹ {planDetailsModal.totalSA.toLocaleString()}</span>
									</li>
								</ul>
							</div>

							<div className="h-[1px] bg-gray-200"></div>

							{/* Premium Section */}
							<div>
								<h4 className="text-sm font-semibold text-gray-700 mb-3">
									PREMIUM BREAK-UP
								</h4>

								<ul className="space-y-3 text-sm">
									<li className="flex justify-between">
										<span>Base Premium</span>
										<span>₹ {planDetailsModal.premium.toFixed(2)}</span>
									</li>

									<li className="flex justify-between">
										<span>GST</span>
										<span>₹ {planDetailsModal.gst.toFixed(2)}</span>
									</li>

									<li className="flex justify-between items-center">
										<span>Total Premium</span>
										<span className="text-xl font-bold text-green-700">
											₹ {planDetailsModal.totalPremium.toFixed(2)}
										</span>
									</li>
								</ul>
							</div>
						</div>

						{/* FOOTER */}
						<div className="p-4 border-t flex justify-end items-center gap-3 bg-gray-50">
							<button
								onClick={() => setPlanDetailsModal(null)}
								className="px-5 py-2 rounded-lg border hover:bg-gray-100 transition"
							>
								Close
							</button>

							<button
								onClick={() => setPurchaseModal(planDetailsModal)}
								className="px-5 py-2 rounded-lg font-semibold shadow bg-primary text-white"
							>
								Buy Now
							</button>
						</div>
					</div>
				</div>
			)}
			{purchaseModal && (
				<div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
					<div className="bg-white rounded-2xl max-w-4xl w-full shadow-xl overflow-hidden">
						{/* Header */}
						<div className="flex justify-between items-center px-6 py-5 border-b bg-gray-50">
							<h2 className="text-xl font-semibold text-gray-800">
								Hospicash Insurance
							</h2>
							<button
								onClick={() => setPurchaseModal(null)}
								className="hover:bg-gray-100 p-2 rounded-full"
							>
								<XMarkIcon className="w-5 h-5 text-gray-600" />
							</button>
						</div>

						{/* 2 Column layout */}
						<div className="grid grid-cols-1 md:grid-cols-2 gap-0">
							{/* LEFT SECTION */}
							<div className="p-6 border-r">
								<h3 className="text-lg font-semibold text-gray-800 mb-6 text-center border-b pb-2">
									Premium Details
								</h3>

								<div className="flex items-center gap-3 mb-5">
									<img
										src="https://assets.futuregenerali.in/header-assets/updated-header-logo/logo.svg"
										alt="provider"
										className="h-12 object-contain"
									/>
									<div className="h-14 w-px bg-gray-300"></div>

									<span className="font-medium text-gray-700 text-sm">
										Generali Central India Insurance Company
									</span>
								</div>

								{/* SUM ASSURED BREAKUP */}
								<h4 className="font-semibold text-gray-600 text-xs mb-2 tracking-wider">
									SUM ASSURED BREAK-UP
								</h4>
								<div className="space-y-2 text-sm text-gray-700 mb-4">
									<div className="flex justify-between">
										<span>Daily Hospitalisation benefit</span>
										<span className="font-medium">
											₹ {purchaseModal.dailyCashAllowance.toLocaleString()}
										</span>
									</div>
									<div className="flex justify-between">
										<span>ICU benefit in home city</span>
										<span className="font-medium">
											₹ {purchaseModal.homeCityICUBenefit.toLocaleString()}
										</span>
									</div>
									<div className="flex justify-between">
										<span>ICU benefit in other than home city</span>
										<span className="font-medium">
											₹ {purchaseModal.nonHomeCityICUBenefit.toLocaleString()}
										</span>
									</div>
									<div className="flex justify-between">
										<span>Convalescence benefit for hospitalisation</span>
										<span className="font-medium">
											₹ {purchaseModal.convalescenceBenefit.toLocaleString()}
										</span>
									</div>
									<div className="h-[1px] bg-gray-200"></div>
									<div className="flex justify-between font-semibold">
										<span>Total Sum Assured</span>
										<span>₹ {purchaseModal.totalSA.toLocaleString()}</span>
									</div>
								</div>

								{/* PREMIUM BREAKUP */}
								<h4 className="font-semibold text-gray-600 text-xs mb-2 tracking-wider">
									PREMIUM BREAK-UP
								</h4>
								<div className="space-y-2 text-sm text-gray-700">
									<div className="flex justify-between">
										<span>Base Premium</span>
										<span>₹ {purchaseModal.premium.toLocaleString()}</span>
									</div>
									<div className="flex justify-between">
										<span>GST (18%)</span>
										<span>₹ {purchaseModal.gst.toLocaleString()}</span>
									</div>
									<div className="h-[1px] bg-gray-200"></div>
									<div className="flex justify-between text-xl font-bold text-green-700">
										<span>Total Premium</span>
										<span>₹ {purchaseModal.totalPremium.toLocaleString()}</span>
									</div>
								</div>
							</div>

							{/* RIGHT SIDE FORM */}
							<div className="p-6 space-y-5">
								<h3 className="text-lg font-semibold text-gray-800 mb-6 text-center border-b pb-2">
									Hospicash Insurance
								</h3>
								<input type="hidden" value={purchaseModal.premiumUID} />

								<div className="grid grid-cols-4 gap-2">
									<div>
										<label className="text-sm font-medium text-gray-700 flex items-center gap-1">
											Title
											<span className="text-red-500">*</span>
										</label>

										<select
											className="w-full border rounded-lg px-3 py-2 mt-1 text-gray-700"
											value={title}
											onChange={(e) => setTitle(e.target.value)}
										>
											<option value="">Select</option>
											<option value="Mr.">Mr.</option>
											<option value="Mrs.">Mrs.</option>
											<option value="Miss">Miss</option>
										</select>

										{submitted && !title && (
											<p className="text-red-500 text-xs mt-1">
												Title is required
											</p>
										)}
									</div>

									<div className="col-span-3">
										<label className="text-sm font-medium text-gray-700 flex items-center gap-1">
											Full Legal Name
											<span className="text-red-500">*</span>
											<div className="relative group cursor-pointer select-none">
												<div className="w-4 h-4 rounded-full bg-gray-200 text-gray-700 text-[10px] flex items-center justify-center font-semibold">
													i
												</div>
												<div className="absolute hidden group-hover:block bg-gray-900 text-white text-xs p-2 rounded-md w-56 z-50 -left-1 top-6 shadow-lg">
													Enter complete legal name. Avoid initials (e.g. “R.
													Kumar”). Use full name like “Raj Kumar Rao”.
												</div>
											</div>
										</label>

										<input
											type="text"
											value={fullName}
											onChange={(e) => {
												let value = e.target.value;
												if (!/^[A-Za-z ]*$/.test(value)) return;
												value = value
													.toLowerCase()
													.replace(/\b\w/g, (c) => c.toUpperCase());
												setFullName(value);
											}}
											className="w-full border rounded-lg px-3 py-2 mt-1"
											placeholder="Rahul Kumar Sharma"
										/>

										{submitted && !fullName && (
											<p className="text-red-500 text-xs mt-1">
												Full name is required
											</p>
										)}
									</div>
								</div>

								<div>
									<label className="text-sm font-medium text-gray-700 flex items-center gap-1">
										Mobile Number
										<span className="text-red-500">*</span>
										<div className="relative group cursor-pointer select-none">
											<div className="w-4 h-4 rounded-full bg-gray-200 text-gray-700 text-[10px] flex items-center justify-center font-semibold">
												i
											</div>
											<div className="absolute hidden group-hover:block bg-gray-900 text-white text-xs p-2 rounded-md w-56 z-50 -left-1 top-6 shadow-lg">
												Enter customer's mobile only. OTP & policy updates will
												be sent to this number.
											</div>
										</div>
									</label>

									<input
										type="tel"
										value={mobile}
										onChange={(e) => {
											const value = e.target.value.replace(/\D/g, "");
											setMobile(value);
										}}
										onKeyDown={(e) => {
											if (["e", "E", "+", "-", "."].includes(e.key))
												e.preventDefault();
										}}
										maxLength={10}
										className="w-full border rounded-lg px-3 py-2 mt-1"
										placeholder="9876543210"
									/>

									{submitted && !mobile && (
										<p className="text-red-500 text-xs mt-1">
											Mobile number is required
										</p>
									)}
								</div>

								<div>
									<label className="text-sm font-medium text-gray-700 flex items-center gap-1">
										Email Id
									</label>

									<input
										type="email"
										className={`w-full border rounded-lg px-3 py-2 mt-1 ${
											emailError ? "border-red-600" : ""
										}`}
										placeholder="rahul.sharma@gmail.com"
										value={email}
										onChange={handleEmailChange}
									/>

									{emailError && (
										<p className="text-red-600 text-xs mt-1">{emailError}</p>
									)}
								</div>

								<div>
									<label className="text-sm font-medium text-gray-700 mb-1 block">
										Date of Birth
									</label>

									<div className="relative">
										<DatePicker
											selected={dob}
											onChange={(date) => setDob(date)}
											dateFormat="dd-MM-yyyy"
											placeholderText="Select Date"
											maxDate={new Date()}
											showYearDropdown
											showMonthDropdown
											dropdownMode="select"
											className="w-full border rounded-lg px-3 py-2 pr-10 cursor-pointer focus:ring-2 focus:ring-primary focus:border-primary"
											calendarClassName="rounded-lg shadow-lg border"
										/>

										{/* Icon INSIDE the input */}
										<CalendarDaysIcon className="w-5 h-5 text-gray-500 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
									</div>
								</div>
							</div>
						</div>

						<div className="px-6 py-4 border-t bg-gray-50 flex justify-end gap-3">
							<button
								onClick={() => setPurchaseModal(null)}
								className="px-5 py-2 rounded-lg border hover:bg-gray-100 transition"
							>
								Cancel
							</button>

							<button
								onClick={handleSubmit}
								disabled={loading}
								className={`px-6 py-2 rounded-lg text-white ${
									loading ? "bg-gray-400 cursor-not-allowed" : "bg-primary"
								}`}
							>
								{loading ? "Proceeding..." : "Proceed"}
							</button>
						</div>
					</div>
				</div>
			)}
			{toast.message && (
				<Toast
					message={toast.message}
					type={toast.type}
					onClose={() => setToast({ message: "", type: "" })}
				/>
			)}
		</div>
	);
};

export default InsurancePortal;
